import { render, staticRenderFns } from "./upgradeGetList.vue?vue&type=template&id=3b968a70&"
import script from "./upgradeGetList.vue?vue&type=script&lang=js&"
export * from "./upgradeGetList.vue?vue&type=script&lang=js&"
import style0 from "./upgradeGetList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports